export default __webpack_public_path__ + "static/media/event-image-1.0325178d.png";